<template>
  <div class="news-container">
    <div class="news-header">
      <img alt="news"
           class="title"
           src="../assets/news-title.svg" />
      <Loud class="loud" />
      <div class="news-nav">
        <a :class="{ active: newsType == '' }"
           v-on:click="handlePressedNewsType('')">
          All
        </a>
        <a :class="{ active: newsType == 'course' }"
           v-on:click="handlePressedNewsType('course')">
          課程
        </a>
        <a :class="{ active: newsType == 'activity' }"
           v-on:click="handlePressedNewsType('activity')">
          活動
        </a>
        <a :class="{ active: newsType == 'rank' }"
           v-on:click="handlePressedNewsType('rank')">
          榜單
        </a>
        <a :class="{ active: newsType == 'private_school' }"
           v-on:click="handlePressedNewsType('private_school')">
          升私中
        </a>
      </div>
      <PulseLoader class="loading"
                   :loading="state == 'loading'"
                   color="#f1d85b"
                   size="20px" />
      <ErrorView v-if="state == 'error'" />
      <div v-if="state == 'display' || state == 'loadingMore'">
        <div class="news-list">
          <NewsCard class="news"
                    v-for="it in news"
                    :key="it.id"
                    :news="it" />
        </div>
        <PulseLoader class="loading"
                     :loading="state == 'loadingMore'"
                     color="#f1d85b"
                     size="20px" />
        <a v-if="state == 'display'"
           class="loadmore"
           v-on:click="loadMore">
          <img src="../assets/drop-down.svg"
               alt="load more" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { of, concat } from "rxjs";
import { distinct, map, concatAll, toArray } from "rxjs/operators";

import Loud from "@/components/Loud.vue";
import NewsCard from "@/components/NewsCard.vue";
import ErrorView from "@/components/ErrorView.vue";
import { withApiClient } from "@/api/ApiClient.js";

const NewsContainer = {
  components: {
    Loud,
    NewsCard,
    PulseLoader,
    ErrorView
  },
  data: function() {
    return {
      newsType: "",
      state: "idle",
      news: []
    };
  },
  mounted() {
    this.handlePressedNewsType(this.newsType);
  },
  methods: {
    handlePressedNewsType: function(type) {
      this.newsType = type;
      this.state = "loading";
      this.apiClient.fetchNewsList(type).subscribe(
        resp => {
          this.state = "display";
          this.news = resp.list;
        },
        () => {
          this.state = "error";
        }
      );
    },
    loadMore: function() {
      this.state = "loadingMore";
      concat(
        of(this.news),
        this.apiClient
          .fetchNewsList(this.newsType, this.news.length)
          .pipe(map(resp => resp.list))
      )
        .pipe(
          concatAll(),
          distinct(it => it.id),
          toArray()
        )
        .subscribe(
          news => {
            this.state = "display";
            this.news = news;
          },
          () => {
            this.state = "error";
          }
        );
    }
  }
};

export default withApiClient(NewsContainer);
</script>

<style lang="scss" scoped>
.news-container {
  margin-top: 35px;
  background-color: #f3f3f4;
  position: relative;
  padding-bottom: 110px;

  &:before {
    content: "";
    display: block;
    background: url("../assets/home-news-header.svg") center no-repeat;
    height: 57px;
    width: 100%;
    position: absolute;
    top: -56px;
    z-index: -1;
  }

  .title {
    display: block;
    margin: 0 auto 36px;
    padding: 32px 0 0;
    width: 155px;
  }

  .loud {
    position: absolute;
    top: -30px;
    left: 30px;
  }

  .news-nav {
    display: flex;
    flex-direction: row;
    max-width: 1024px;
    margin: auto;
    & > a {
      margin: 0 10px;
      cursor: pointer;
      display: block;
      border-radius: 16px;
      background-color: white;
      color: #6b6b6b;
      flex: 1;
      text-align: center;
      padding: 5px 0;
      font-weight: bold;

      &.active {
        color: white;
        background-color: #c4cb7a;
      }
    }
  }

  .loading {
    text-align: center;
    margin: 30px;
  }

  .news-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .news {
      width: 340px;
      margin: 39px 13px 0;
    }
  }

  .loadmore {
    width: 62px;
    height: 22px;
    display: block;
    cursor: pointer;
    margin: 66px auto 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

@media (max-width: 1023px) {
  .news-nav {
    font-size: 12px;

    a {
      margin: 0 5px !important;
    }
  }

  .loud {
    top: 0px !important;
    left: 10px !important;
  }
}
</style>
